import React from 'react';
import styled from 'styled-components';
import {COLORS, FONTS, SIZES, Typography} from '@fupa/fupa-uikit';

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 10001;
  background-color: ${COLORS.black};
`;

const Loader = styled.div`
  border: ${SIZES['8']} solid ${COLORS.lighterGrey};
  border-top: ${SIZES['8']} solid ${COLORS.white};
  border-radius: 50%;
  width: ${SIZES['64']};
  height: ${SIZES['64']};
  animation: spin 2s linear infinite;
  margin-bottom: ${SIZES['16']};

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const StyledTypography = styled(Typography)`
  font-size: ${FONTS['16']};
`;

export const LoadingOverlay = ({show}) => {
  return show ? (
    <OverlayContainer>
      <Loader />
      <StyledTypography variant='title1'>Videoplayer wird geladen...</StyledTypography>
    </OverlayContainer>
  ) : null;
};
